import { render, staticRenderFns } from "./NewContents.vue?vue&type=template&id=b2ebb136&scoped=true&"
import script from "./NewContents.vue?vue&type=script&lang=js&"
export * from "./NewContents.vue?vue&type=script&lang=js&"
import style0 from "./NewContents.vue?vue&type=style&index=0&id=b2ebb136&lang=scss&scoped=true&"
import style1 from "./NewContents.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ebb136",
  null
  
)

export default component.exports